import { Action } from 'redux';
import { NlpSetting } from '../../ts/models/IDataSourceInfo';
import { UpdateNlpSetting } from './AppActionTypes';

export interface UpdateNlpSettingAction extends Action {
  nlpSetting: NlpSetting;
}

export const updateNlpSetting = (nlpSetting: NlpSetting): UpdateNlpSettingAction => ({
  type: UpdateNlpSetting,
  nlpSetting,
});
